import React, { useState, useRef } from "react";
import styled from "styled-components";
import Container from "../../Components/Container";

import Card1 from "../../assets/images/card1.svg";
import Card2 from "../../assets/images/card2.svg";
import Card3 from "../../assets/images/card3.svg";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Row from "../../Components/Row";

const cards = [
  {
    title: "Conecte o Whatsapp",
    subtitle: "Em minutos, o Alfred está no seu número de atendimento.",
    content: <img src={Card1} alt="Card 1" />,
  },
  {
    title: "Configure seu agente",
    subtitle: "Aqui vai algumas instruções básicas para o seu agente.",
    content: <img src={Card2} alt="Card 2" />,
  },
  {
    title: "Alimente a base de conhecimento",
    subtitle: "Suba PDFs, textos, FAQs ou qualquer conteúdo.",
    content: <img src={Card3} alt="Card 3" />,
  },
];

const Title = styled.h1`
  font-weight: 700;
  font-size: 40px;
  color: #fff;
  margin-bottom: 50px;
`;

const SlideContent = styled.div`
  color: #fff;
  text-align: center;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;

  img {
    width: 100% !important;
    max-width: 700px !important;
    height: auto;

    @media (max-width: 768px) {
      width: 300px !important;
    }
  }
`;

interface CardsDescriptionProps {
  active: boolean;
}

const CardsDescription = styled.div<CardsDescriptionProps>`
  display: flex;
  flex-direction: column;
  color: #fff;
  align-items: center;

  h2 {
    font-size: 20px;
    margin-bottom: 4px;
  }

  p {
    font-size: 16px;
    max-width: 300px;
  }

  h2,
  p {
    opacity: ${(props) => (props.active ? 1 : 0.4)};
    transition: opacity 0.3s ease;
  }

  @media (max-width: 768px) {
    display: ${(props) => (props.active ? "flex" : "none")};
  }
`;

const DotsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 200px;
  align-items: center;
  width: 100%;
  margin-top: 20px;
`;

interface DotProps {
  active?: boolean;
  index?: number;
}

const Dot = styled.div<DotProps>`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: ${(props) => (props.active ? "#F5E64F" : "#fff")};
  margin: 0 4px;
  cursor: pointer;
`;

const About = () => {
  const [currentSlide, setCurrentSlide] = useState(1);
  const sliderRef = useRef<Slider | null>(null);

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    centerMode: true,
    centerPadding:window.innerWidth < 576 ?  "0px" : "25%", // fui obrigado a fazer assim
    arrows: false,
    initialSlide: 1,
    afterChange: setCurrentSlide,
    
  };

  return (
    <Container style={{ textAlign: "center" }} id="section-2" full>
      <Title>
        Como <span style={{ color: "#E4DA1B" }}>Funciona</span>
      </Title>
      <Slider ref={sliderRef} {...settings}>
        {cards.map((card, index) => (
          <SlideContent
            key={index}
            style={{
              opacity: currentSlide === index ? 1 : 0.1,
              transition: "opacity 0.3s ease",
            }}
          >
            {card.content}
          </SlideContent>
        ))}
      </Slider>

      <DotsWrapper>
        {cards.map((card, dotIndex) => (
          <CardsDescription
            key={dotIndex}
            active={dotIndex === currentSlide} // 👈 aqui
          >
            <Dot
              index={dotIndex}
              active={dotIndex === currentSlide}
              onClick={() => sliderRef.current?.slickGoTo(dotIndex)}
            />
            <h2>{card.title}</h2>
            <p>{card.subtitle}</p>
          </CardsDescription>
        ))}
      </DotsWrapper>
    </Container>
  );
};

export default About;
